var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formHeader)?_c('p',{directives:[{name:"html-sanitize",rawName:"v-html-sanitize",value:(_vm.formHeader),expression:"formHeader"}],attrs:{"id":"form-viewer-header-d76k2r"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }